import { base64Encode, getNanoId, getStackList } from '@fpkg/stats-utils';
import { BaseEvent, PlainObject } from '../types';
import getCurCommonParams from './getCurCommonParams';

/**
 * 生成错误上报数据格式
 * @param eventInfo
 */
export default function createErrorReportEvent(eventInfo: BaseEvent, commonParams: PlainObject): BaseEvent {
  let { event = 'ErrorReport', event_code = '', event_name = '', error = '', ...info } = eventInfo || {};

  // 一些内置事件没有event_code，event_name字段
  if (!event_code) {
    event_code = event;
  }
  if (!event_name) {
    event_name = event;
  }

  if (error && error instanceof Error) {
    error = getStackList(error);
  }

  // 随机数
  const nonce = getNanoId();

  const data = {
    event,
    event_code,
    event_name,
    stack_list: error,
    nonce,
    level: 'error',
    client_time: Date.now(),
    sign: '',
    // 公共属性
    ...getCurCommonParams(commonParams),
    ...info,
  };

  // 告警上报，需要加密字段
  const sign = encodeURIComponent(
    [
      `event=${event}`,
      `event_code=${event_code}`,
      // @ts-ignore
      `system_code=${data.system_code}`,
      // @ts-ignore
      `product_code=${data.product_code}`,
      `nonce=${nonce}`,
      `client_time=${data.client_time}`,
    ].join('&')
  );
  data.sign = base64Encode(sign);

  return data as BaseEvent;
}
